<template>
  <div>
    <div class="col-xs-12 map-container col-lg-6">
      <dc-map v-if="map_data" v-bind="map_data" :width="480" :height="400"></dc-map>
    </div>
    <div class="col-xs-12 col-md-12 col-lg-6 table_stores" style="height: 500px; overflow-y: scroll;">
      <div class="table-search">
        <div class="row search-box">
          <div class="col-lg-12">
            <input type="search" placeholder="Search" class="form-control" style="margin-bottom: 15px;" v-on:keyup="filterText(searchFor)" v-model="searchFor">
          </div>
        </div>
        <div>
          <table :ref="tableName" :id="tableName" :class="tableClass"></table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import DcDataTable from '../DcDataTable';
  import dc from 'dc';
  import DcMap from '../DcMap';
  import utils from '@/modules/utils';
  let crossfilter = dc.crossfilter;

  /* eslint-disable */
  export default {
    name: 'dc-map-table',
    props: ['mapJson', 'tableCsv', 'name', 'columns', 'tableClass', 'sortFunction',
            'dimensionFunction', 'textDimensionFunction', 'maxFunction',
            'filterFunction', 'wrapMaxColumn', 'mapTitle'],
    components: {
      DcDataTable,
      DcMap
    },
    data: function() {
      return {
        searchFor: "",
        map_data: null,
        chartGroupName: 'map-chart-group-name',
        legendWidth: 410
      };
    },
    mounted: function() {
      this.$nextTick(function () {
        this.setupCharts();
      });
    },
    computed: {
      mapName: function() {
        return this.name+"-map";
      },
      tableName: function() {
        return this.name+"-table";
      },
      legendName: function() {
        return this.name+"-legend";
      }
    },
    methods: {
      filterText: function(text) {
        if (this.textDimension == null) {
          return;
        }
        var filteredTest = this.textDimension.filter(utils.filter.filterText(text));
        this.dataTable.render();
      },
      reset: function() {
        this.visitMap.reset();
      },
      setupCharts: function() {
        var self = this;
        var dataTable = dc.dataTable("#"+self.tableName, self.name);

        this.dataTable = dataTable;

        self.$dataStore.csv(self.tableCsv, function(placesCsv) {
          var placesData = crossfilter(placesCsv);
          var provinces = placesData.dimension(self.dimensionFunction);
          if (self.textDimensionFunction !== undefined) {
            self.textDimension = placesData.dimension(self.textDimensionFunction);
          }

          dataTable
            .dimension(provinces)
            .group(function(d) { return false; })
            .order(d3.descending)
            .sortBy(self.sortFunction)
            .size(Infinity)
            .showGroups(false)
            .columns(self.columns)
            .on('pretransition', function (table) {
              table.selectAll('td.dc-table-column')
                .on('click',function(d){
                  self.$emit('rowClicked', d);
              })
            });

          dataTable.render();

          var sum = provinces.group().reduceCount();

          self.$dataStore.json(self.mapJson, function (provincesJson) {
            var allSum = sum.top(sum.size());
            var largestSum = allSum[0].value;
            var smallestSum = allSum[sum.size() - 1].value;
            var d3ColorRange = d3.scale.linear()
              .range(["lightgrey", "#084081", "#ccebc5"])
              .domain([0, smallestSum, largestSum]);

            self.map_data = {
              dcGroup: self.name,
              mapJson: provincesJson,
              dimension: provinces,
              crossfilterGroup: sum,
              initFunc: function(dcMap, d3Legend, getCenterProjection, initLegend) {
                self.visitMap = dcMap;

                dcMap
                  .colors(d3ColorRange)
                  .title(self.mapTitle)
                  .addFilterHandler(function (filters, filter) {
                    if (utils.indexPosition(allSum,filter,"key") > -1){
                      var provinceMapFeature = provincesJson.features.find(function(f) { return f["properties"]["level1"] === filter; });
                      dcMap.projection(getCenterProjection(provinceMapFeature));
                      self.$_am.logEvent("click",self.$route.name,"geo-map",new Date().toISOString())
                      return [filter];
                    }else {
                      return [];
                    }
                  })
                  .removeFilterHandler(function(filters, filter) {
                    dcMap.projection(getCenterProjection(provincesJson));
                    return [];
                  })

                dcMap.reset = function() {
                  dcMap.filterAll();
                  dcMap.projection(getCenterProjection(provincesJson));
                  dataTable.filterAll()
                  dc.redrawAll(self.name);
                };

                d3Legend
                  .shapeWidth(35)
                  .cells(provinces.group().size() >= 5 ? Math.min(10, largestSum - smallestSum + 1) : 3)
                  .labelFormat(function(d) {
                    return (d === 0 ? "0" : "<" + d3.format(".0f")(d) );
                  });

                dcMap.render();
                initLegend(d3Legend);
              }
            };
          });
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/widgets/DcMapTable.vue